var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _linearGradient9, _path10, _linearGradient10, _path11, _linearGradient11, _path12, _linearGradient12, _path13, _linearGradient13, _path14, _linearGradient14, _path15, _linearGradient15, _path16, _linearGradient16, _path17, _linearGradient17, _path18, _linearGradient18, _path19, _linearGradient19, _path20, _linearGradient20, _path21, _linearGradient21, _path22, _linearGradient22, _path23, _linearGradient23, _path24, _linearGradient24, _path25, _linearGradient25, _path26, _linearGradient26, _path27, _linearGradient27, _path28, _linearGradient28, _path29, _linearGradient29, _path30, _linearGradient30, _path31, _linearGradient31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherReceivables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: -726.173,
    y1: -724.509,
    x2: -725.173,
    y2: -724.509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M62.336 47.14H44.642V30.47c0-4.701 3.984-8.549 8.842-8.549 4.868 0 8.852 3.848 8.852 8.549v16.67z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M53.489 21.805h79.716c4.868 0 8.852 3.85 8.852 8.545V138.466H62.3l.036-91.325"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 40.719,
    x2: 85.373,
    y2: 40.719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M84.123 37.455l-6.528 6.529"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 47.747,
    x2: 99.429,
    y2: 47.747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M98.179 37.455L77.595 58.04"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 54.113,
    x2: 112.169,
    y2: 54.113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M110.919 37.455L77.595 70.77"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 60.939,
    x2: 125.812,
    y2: 60.939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M124.562 37.455L77.595 84.423"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 78.493,
    y1: 73.023,
    x2: 127.605,
    y2: 73.023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.355 49.717L79.743 96.329"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 87.452,
    x2: 127.607,
    y2: 87.452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 63.07l-48.762 48.763"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 78.524,
    y1: 100.005,
    x2: 127.607,
    y2: 100.005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 76.713l-46.583 46.584"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 92.58,
    y1: 107.038,
    x2: 127.607,
    y2: 107.038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 90.779L93.83 123.297"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 105.041,
    y1: 113.264,
    x2: 127.607,
    y2: 113.264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_9_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 103.231l-20.065 20.066"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 118.684,
    y1: 120.085,
    x2: 127.607,
    y2: 120.085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_10_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 116.874l-6.423 6.423"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_11_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M84.123 37.455l-6.528 6.529"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_12_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M84.123 37.455l-6.528 6.529"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_13_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M98.179 37.455L77.595 58.04"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_14_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M98.179 37.455L77.595 58.04"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_15_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M110.919 37.455L77.595 70.77"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_16_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M110.919 37.455L77.595 70.77"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_17_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M124.562 37.455L77.595 84.423"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_18_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M124.562 37.455L77.595 84.423"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_19_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.355 49.717L79.743 96.329"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_20_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.355 49.717L79.743 96.329"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_21_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 63.07l-48.762 48.763"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_22_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 63.07l-48.762 48.763"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_23_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 76.713l-46.583 46.584"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_24_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 76.713l-46.583 46.584"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_25_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 90.779L93.83 123.297"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_26_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 90.779L93.83 123.297"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_27_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 103.231l-20.065 20.066"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_28_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 103.231l-20.065 20.066"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_29_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 116.874l-6.423 6.423"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f",
    gradientUnits: "userSpaceOnUse",
    x1: 76.344,
    y1: 80.376,
    x2: 127.607,
    y2: 80.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_30_26f782587600d8f64db83d8ec7e274e3e987bdcefe719633c31aecdde401f77f)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M126.357 116.874l-6.423 6.423"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherReceivables);
export default __webpack_public_path__ + "static/media/otherReceivables.c9097148f68d46ba1c6f82f48ab6c21a.svg";
export { ForwardRef as ReactComponent };